import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../../assets/css/mainMenu.css";
import "../../../assets/css/addunit.css";

import edit from "../../../assets/icons/edit.svg";
import close from "../../../assets/icons/close.svg";


import ArrowDown from "../../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../../assets/icons2/ArrowUp.svg";
import recyclebin from "../../../assets/icons/recycle-bin2.svg";

import plus1 from "../../../assets/icons/plus1.svg";
import search2 from "../../../assets/icons/search2.svg";
import AddModal from "../MasterTable/AddModal";
import EditModal from "../MasterTable/EditModal";
import Loader from "../../../Components/LoaderAndSpinner/Loader";
import { useDispatch } from "react-redux";
import { fetchMenuItems } from "../../../Redux/Menu/MenuSlice";
import fetchWrapper from "../../../AuthMiddleware/FetchWrapper";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../Components/Pagination/Pagination";
import { hasPermission } from "../../../Services/authUtils";

const MasterTable = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [masters, setMasters] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  // const [currentPageMaster, setCurrentPageMaster] = useState(1);
  // const [itemsPerPage] = useState(10);
  const [actionType, setActionType] = useState(null);
  const [actionMasterId, setActionMasterId] = useState(null);
  const [parameters, setParameters] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "master_name",
    order: "asc",
  });
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);

  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const navigate = useNavigate();

  const fetchMasters = async () => {
    try {
      const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/paginate-masters${queryString}`;
      // Log the API URL

      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate // Pass navigate here if needed
      );

      // Log the data received from the API
      setMasters(data.masters);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);

    } catch (error) {
      console.error("Error fetching masters:", error);
      toast.error(error.message || "Error fetching masters");
    }
  };

  const fetchParameterTypes = async () => {
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/parameter-type/getall`,
        {
          method: "POST",
        }
      );



      // Update the parameters state with the fetched data
      setParameters(data);

      return data; // Return the fetched data
    } catch (error) {
      console.error("Error fetching parameter types:", error);
      throw error; // Re-throw the error to handle it in the calling code
    }
  };

  // const indexOfLastItemMaster = currentPageMaster * itemsPerPage;
  // const indexOfFirstItemMaster = indexOfLastItemMaster - itemsPerPage;
  // const currentMasters = masters.slice(
  //   indexOfFirstItemMaster,
  //   indexOfLastItemMaster
  // );

  const handleOpenAddModal = () => {
    setShowAddModal(true);
  };

  const handleOpenEditModal = (master) => {
    setSelectedMaster(master);
    setShowEditModal(true);
  };

  const handleMasterDeleteRestore = (masterId, currentStatus) => {
    setActionMasterId(masterId);
    setActionType(currentStatus ? "Inactive" : "Restore");
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/soft-delete-master/${actionMasterId}`;


    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate // Pass navigate here if needed
      );

      setLoading(false);
      // Log successful API call

      // Update the status of the master
      const updatedMasters = masters.map((master) =>
        master._id === actionMasterId
          ? { ...master, status: actionType === "Inactive" ? false : true }
          : master
      );
      setMasters(updatedMasters);
      setConfirmModal(false);
      toast.success(`Master ${actionType} Successful`);
      dispatch(fetchMenuItems());
    } catch (error) {
      setLoading(false);
      console.error(`Error ${actionType} master:`, error);
      toast.error(`Error while ${actionType} master`);
    }
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/soft-delete-master/${checkedItems[0]}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ids: checkedItems,
          }),
        },
        navigate // Pass navigate here if needed
      );

      setLoading(false);


      const updatedMasters = masters.map((master) =>
        checkedItems.includes(master._id)
          ? { ...master, status: false }
          : master
      );

      setMasters(updatedMasters);
      setBulkDeleteModal(false);
      toast.success(`All the selected items are Inactivated successfully`);
      setAllChecked(false);
      setCheckedItems([]);
      dispatch(fetchMenuItems());
    } catch (error) {
      setLoading(false);
      console.error(`Error deleting selected masters:`, error);
      toast.error(`Error deleting selected masters`);
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };
  const handleStatusChange = (status) => {
    setStatusFilter(status === "all" ? "" : status);
    setPage(1); // Reset to the first page when changing status
  };

  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    setAllChecked(newCheckedStatus);
    if (newCheckedStatus) {
      setCheckedItems(
        masters.filter((master) => master.status).map((master) => master._id)
      );
    } else {
      setCheckedItems([]);
    }
  };

  const handleRowCheckboxChange = (masterId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(masterId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== masterId)
        : [...prevCheckedItems, masterId];

      setAllChecked(
        updatedCheckedItems.length ===
        masters.filter((master) => master.status).length
      );
      return updatedCheckedItems;
    });
  };
  useEffect(() => {
    fetchParameterTypes();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchMasters(); // Perform search
    }
  };
  useEffect(() => {
    fetchMasters();
  }, [
    page,
    pageSize,
    sortBy,
    // search,
    // totalPages,
    // currentPage,
    // totalItems,
    statusFilter,
    // masters.length,
  ]);

  return (
    <>
      <div className="">
        <div className="container">
          <div className="show-breadcrumb pt-3">
            <div className="">
              <h5>Masters</h5>
            </div>

            <nav className="breadcrumb-nav" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a className="">Configure</a>
                </li>

                <li className="breadcrumb-item active" aria-current="page">
                  Masters
                </li>
              </ol>
            </nav>
          </div>
          <div className="">
            <div
              className="navbar-3 d-flex justify-content-between"
              style={{ marginTop: "-3px" }}
            >
              <div className="d-flex gap-3">
                <div className="search-container ">
                  <img src={search2} alt="Search" />
                  <input
                    type="text"
                    className=""
                    id="search"
                    value={search}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Search "
                    name="search"
                    autoComplete="off"
                  />
                </div>
                <div>
                  {checkedItems.length > 0 && (
                    <button
                      id="bulkDelete"
                      className="bulkDelete-btn"
                      style={{ display: "block" }}
                      onClick={() => setBulkDeleteModal(true)}
                    >
                      <span>
                        <img
                          src={recyclebin}
                          height="24px"
                          width="24px"
                          alt=""
                        />
                      </span>{" "}
                      Inactivate
                    </button>
                  )}
                </div>
              </div>
              <div className="d-flex gap-3">
                <div className="dropdown">
                  <select
                    id="cars"
                    className=" select-unit textarea"
                    value={statusFilter}
                    onChange={(e) => handleStatusChange(e.target.value)}
                    style={{
                      width: "120px",
                      height: "calc(100% - 1px)", // Adjust height to be 3px less
                    }}
                  >
                    <option value="">All</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                {hasPermission(["masters.create"]) && (
                  <div>
                    <button
                      type="button"
                      id="openPopup"
                      className="btn-bg"
                      onClick={handleOpenAddModal}
                    >
                      <span className="plus-icon">
                        <img src={plus1} alt="Plus Icon" />
                      </span>
                      Add Master
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div style={{ marginTop: "-10px" }}>
              <div className="table-responsive">
                <table className="table  align-middle table-text">
                  <thead className="table-head align-middle ">
                    <tr>
                      <th className="table-check">
                        <input
                          type="checkbox"
                          checked={allChecked}
                          onChange={handleHeaderCheckboxChange}
                        />
                      </th>
                      <th className="col">ID</th>
                      <th
                        className="col text-uppercase"
                        onClick={() => handleSortChange("master_name")}
                      >
                        Master NAME{" "}
                        {sortBy.field === "master_name" && (
                          <span>
                            {sortBy.order === "asc" ? (
                              <img src={ArrowUp} alt="ArrowUp" />
                            ) : (
                              <img src={ArrowDown} alt="ArrowDown" />
                            )}
                          </span>
                        )}
                      </th>
                      {/* <th className="col">SLUG</th> */}
                      <th className="col text-uppercase">
                        DISPLAY Name Singular
                      </th>
                      <th className="col text-uppercase">
                        Display Name Plural
                      </th>
                      {/* <th className="col">ICON</th> */}
                      <th className="col text-uppercase">Table Name</th>
                      <th className="col text-uppercase">Status</th>
                      {(hasPermission(["masters.update"]) ||
                        hasPermission(["masters.delete"])) && (
                          <th className="col-2 text-uppercase">Action</th>
                        )}
                    </tr>
                  </thead>
                  <tbody>
                    {masters.map((master, index) => (
                      <tr
                        key={master._id}
                        className={master.status ? "" : " disabled text-muted"}
                      // onClick={() => setSelectedMaster(master)}
                      >
                        <td className="table-check">
                          <input
                            type="checkbox"
                            checked={checkedItems.includes(master._id)}
                            onChange={() => handleRowCheckboxChange(master._id)}
                            disabled={!master.status}
                          />
                        </td>
                        <td className="col">{index + startIndex}</td>
                        <td className="col">{master.master_name}</td>
                        {/* <td className="col">{master.slug}</td> */}
                        <td className="col">{master.display_name_singular}</td>
                        <td className="col">{master.display_name_plural}</td>
                        {/* <td className="col">{master.icon}</td> */}
                        <td className="col">{master.model_name}</td>
                        <td className="col">
                          {master.status ? (
                            <span className="active-status">Active</span>
                          ) : (
                            <span className="inactive">Inactive</span>
                          )}
                        </td>
                        {(hasPermission(["masters.update"]) ||
                          hasPermission(["masters.delete"])) && (
                            <td>
                              <div className="action-icons d-flex justify-content-left align-items-center ">
                                {master.status &&
                                  hasPermission(["masters.update"]) && (
                                    <button
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                      }}
                                      className="align-content-center me-3"
                                      onClick={() => handleOpenEditModal(master)}
                                    >
                                      <img src={edit} alt="edit" />
                                    </button>
                                  )}
                                {hasPermission(["masters.delete"]) && (
                                  <span className="align-content-center switcher">
                                    <label className="switch switch1">
                                      <input
                                        type="checkbox"
                                        id={`customSwitch${master._id}`}
                                        checked={master.status} // If not deleted, checkbox is checked
                                        onChange={() =>
                                          handleMasterDeleteRestore(
                                            master._id,
                                            master.status
                                          )
                                        }
                                      />
                                      <span className="slider slider1 round"></span>
                                    </label>
                                  </span>
                                )}
                              </div>
                            </td>
                          )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              pageSize={pageSize}
              onPageSizeChange={handlePageSizeChange}
              totalItems={totalItems}
              startIndex={startIndex}
              endIndex={endIndex}
            />

            {/* Confirmation Modal Content */}
            <div
              id="overlay"
              className={`modal fade ${confirmModal ? "show" : ""}`}
              tabIndex="-1"
              role="dialog"
              style={{
                zIndex: 30,
                display: confirmModal ? "block" : "none",
                transition: "width 2s",
              }}
            >
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <div className="addunit-card Width 25%">
                    <div className="addunit-header">
                      <h4 className="modal-title">
                        {actionType === "Restore" ? "Restore " : "Inactivate "}
                        Master
                      </h4>
                      <button
                        style={{ border: "none", backgroundColor: "inherit" }}
                        type="button"
                        className="close"
                        onClick={() => setConfirmModal(false)}
                      >
                        <img
                          src={close}
                          width="28px"
                          height="28px"
                          alt="Close"
                        />
                      </button>
                    </div>
                    <div className="addunit-form">
                      <p>
                        Are you sure you want to{" "}
                        {actionType === "Restore" ? "restore" : "inactivate"}{" "}
                        this master?
                      </p>
                    </div>
                    <div className="addunit-card-footer justify-content-between">
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => setConfirmModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="update-btn"
                        onClick={confirmAction}
                      >
                        {actionType === "Restore" ? "Restore" : "Inactivate"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Bulk Delete Modal */}
            <div
              id="overlay"
              className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
              tabIndex="-1"
              role="dialog"
              style={{
                zIndex: 30,
                display: bulkDeleteModal ? "block" : "none",
                transition: "width 2s",
              }}
            >
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <div className="addunit-card Width 25%">
                    <div className="addunit-header">
                      <h4>Bulk Inactivate</h4>
                      <button
                        style={{ border: "none", backgroundColor: "inherit" }}
                        type="button"
                        className="close"
                        onClick={() => setBulkDeleteModal(false)}
                      >
                        <img
                          src={close}
                          width="28px"
                          height="28px"
                          alt="Close"
                        />
                      </button>
                    </div>
                    <div className="bulk-delete-unit">
                      <img src={recyclebin} width="48px" height="48px" />

                      <h4 className="delete-unit-h4">Inactivate Masters</h4>
                      <p className="delete-unit-text">
                        Are you sure you want inactivate all the selected
                        masters?
                      </p>
                    </div>
                    <div className="addunit-card-footer justify-content-between">
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => setBulkDeleteModal(false)}
                      >
                        CANCEL
                      </button>
                      <button
                        type="button"
                        className="update-btn"
                        onClick={handleBulkDelete}
                      >
                        CONFIRM
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <AddModal
          show={showAddModal}
          handleClose={() => setShowAddModal(false)}
          onAdd={() => {
            fetchMasters();
            setShowAddModal(false);
          }}
          parameters={parameters}
        />
        <EditModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          master={selectedMaster}
          onEdit={() => {
            fetchMasters();
            setShowEditModal(false);
          }}
          parameters={parameters}
        />
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default MasterTable;
